import { useEffect } from "react";

const SITE_URL = "https://gdminstallations.it";
const DEFAULT_IMAGE = `${SITE_URL}/images/hero/hero.png`;
const SITE_NAME = "GDM Installations";

function ensureMeta(attr, key, content) {
  if (!content) return;

  let element = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function ensureLink(rel, href) {
  if (!href) return;

  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

function ensureJsonLd(id, data) {
  if (!data) return;

  let script = document.head.querySelector(`script[data-seo-id="${id}"]`);
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-id", id);
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export function buildAbsoluteUrl(path = "/") {
  if (!path || path === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export default function usePageSeo({
  lang = "IT",
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  robots = "index, follow",
  keywords,
  jsonLd,
}) {
  useEffect(() => {
    const canonical = buildAbsoluteUrl(path);
    const locale = lang === "IT" ? "it_IT" : "en_US";

    document.title = title;
    document.documentElement.lang = lang === "IT" ? "it" : "en";

    ensureMeta("name", "description", description);
    ensureMeta("name", "robots", robots);
    ensureMeta("name", "author", SITE_NAME);
    ensureMeta("name", "keywords", keywords);

    ensureMeta("property", "og:type", "website");
    ensureMeta("property", "og:locale", locale);
    ensureMeta("property", "og:site_name", SITE_NAME);
    ensureMeta("property", "og:title", title);
    ensureMeta("property", "og:description", description);
    ensureMeta("property", "og:url", canonical);
    ensureMeta("property", "og:image", image);

    ensureMeta("name", "twitter:card", "summary_large_image");
    ensureMeta("name", "twitter:title", title);
    ensureMeta("name", "twitter:description", description);
    ensureMeta("name", "twitter:image", image);

    ensureLink("canonical", canonical);
    ensureJsonLd("page-jsonld", jsonLd);
  }, [description, image, jsonLd, keywords, lang, path, robots, title]);
}

